import { apiFetch } from './apiClient';

export const journalTransactionKey = transaction => transaction.settlementId || transaction.settlement_id || transaction.paymentReference || transaction.payment_reference || transaction.cashEntryId || transaction.id;

// A journal row identifies a paid settlement, not the mutable order header.
// Never fall back to the parent order if this receipt cannot be verified.
export async function loadJournalSettlementDetails(transaction, fetcher = apiFetch) {
  const id = transaction?.settlementId || transaction?.settlement_id;
  if (!id) return null;
  const response = await fetcher(`/api/split-bills/settlements/${encodeURIComponent(id)}/receipt`, { includeBearer:true, cache:'no-store' });
  const receipt = await response.json();
  if (!response.ok) throw new Error(receipt.error || 'Reçu scindé indisponible. Réessayez le chargement.');
  const reference = transaction.paymentReference || transaction.payment_reference;
  if (receipt.settlement_id !== id || !receipt.payment_reference || (reference && receipt.payment_reference !== reference) || !Array.isArray(receipt.items) || !receipt.items.length) {
    throw new Error('Le reçu ne correspond pas au règlement sélectionné. Réimpression interrompue.');
  }
  return {
    settlement_id:receipt.settlement_id,payment_reference:receipt.payment_reference,
    order:{payment_number:receipt.payment_number,total_amount:receipt.total,subtotal:receipt.subtotal,
      discount_amount:receipt.discount_amount,amount_received:receipt.amount_received,change_given:receipt.change_given,
      table_number:receipt.table_number,cashier_name:receipt.cashier_name,server_name:receipt.server_name,
      paid_at:receipt.timestamp,created_at:receipt.timestamp,payment_breakdown:receipt.payment_methods},
    items:receipt.items,reserve:receipt.reserve || null,
  };
}
